module.exports = __webpack_public_path__ + "static/media/header__bg.418b0aa2.png";